import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useEffect } from "react";
import Loader from "../Common/Loader";
import LoaderForSearch from "../Common/LoaderForSearch";
import { AESEncryption, ApiResDecrypt, noDataFound } from "../../CommonMethhods/CommonMethods";

function OMSHome(props) {
  const { URL, mainType } = props;
  const [panindDataList, setPandingDataList] = useState([]);
  const [searchVal, setSearchVal] = useState("");
  const [loader, setLoader] = useState(false);
  const storeToken = localStorage.getItem("ssoToken");
  let navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [count, setCount] = useState();
  const [finalError, setFinalError] = useState(false);

  if (storeToken == null) {
    navigate("/");
  }

  function showClientDetils(results) {
    if (results) {
      localStorage.setItem("panNo", results.panNo);
      localStorage.setItem("mobile", results.mobile);
      localStorage.setItem("ClientName", results.name);
      navigate(
        mainType === "Retail" ? "/retail-client-details" : "/hni-client-details"
      );
    }
  }

  const pendingData = async (pageNo = 1, searchKey = "") => {
    if (page === 1) {
      setLoader(true);
    }

    try {
      let payload=  { search: searchKey, pageNo: pageNo, pageSize: 10 }
      const encResponse = await axios.post(
        `${URL}`,
        AESEncryption(payload),
        {
          headers: {
            "content-Type": "application/json",
            reserv: 1,
            Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
          },
        }
      );
      let response = ApiResDecrypt(encResponse.data);


      const res = response?.data;
      console.log(response?.status, "status");
      if (response?.status === 0) {
        setFinalError(false);
        setCount(res?.totalCount);
        if (pageNo > 1) {
          setPandingDataList((prev) => {
            return [...prev, ...res?.pandingList];
          });
        } else {
          setPandingDataList(res?.pandingList);
        }
      } else {
        setFinalError(response?.message);
        setPandingDataList([]);
      }
    } catch (error) {
      setPandingDataList([]);
      setFinalError(error?.message);
    } finally {
      setLoader(false);
      setScrollLoader(false);
    }
  };
  useEffect(() => {
    pendingData(1, searchVal);
  }, []);

  useEffect(() => {
    if (page > 1) {
      pendingData(page, searchVal);
    }
  }, [page]);

  const handleChange = (e) => {
    pendingData(1, e.target.value);
    setPage(1);
    setSearchVal(e.target.value);
  };
  const handleScroll = (e) => {
    const a = e.target;
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoader) {
      if (!(count <= 10 * page)) {
        setPage((prev) => prev + 1);
        setScrollLoader(true);
      }
    }
  };

  return (
    <>
      <div>
        <h2 className="card-title">Pending Cases To Be Cleared As On Date</h2>
      </div>
      <div className="search-box">
        <div className="form-group">
          <div className="for-position oms-search">
            <input
              type="text"
              className="input-st"
              placeholder="Search here..."
              autoComplete="off"
              value={searchVal}
              onChange={(e) => handleChange(e)}
            />
          </div>
        </div>
      </div>

      <div className="for-grid-section">
        <div className="table-responsive scroll-table report-table-wrapper">
          <table className="table">
            {loader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : (
              panindDataList &&
              panindDataList.length > 0 && (
                <>
                  <thead>
                    <tr>
                      <th scope="col">Party Code</th>
                      <th scope="col" className="text-center">
                        EKYC
                      </th>
                      <th scope="col" className="text-center">
                        EKYC-Id
                      </th>
                      <th scope="col" className="text-center">
                        Name
                      </th>
                      <th scope="col" className="text-center">
                        PAN
                      </th>
                      <th scope="col" className="text-center">
                        Mobile
                      </th>
                      <th scope="col" className="text-center">
                        Date
                      </th>
                    </tr>
                  </thead>
                  <tbody onScroll={(e) => handleScroll(e)}>
                    {panindDataList.map((item, index) => {
                      return (
                        <tr key={index} onClick={() => showClientDetils(item)}>
                          <td>{item?.clientCode || "-"}</td>
                          <td>{item?.ekyc || "-"}</td>
                          <td>{item?.ekycId || "-"}</td>
                          <td>{item?.name || "-"}</td>
                          <td>{item?.panNo || "-"}</td>
                          <td>{item?.mobile || "-"}</td>
                          <td>
                            {item?.lastUpdated
                              ? item?.lastUpdated.split("T")[0]
                              : "-"}
                          </td>
                        </tr>
                      );
                    })}
                    {scrollLoader && (
                      <div className="loader-center">
                        <LoaderForSearch />
                      </div>
                    )}
                  </tbody>
                </>
              )
            )}
            {finalError && <p>{noDataFound(finalError)}</p>}
          </table>
        </div>
      </div>
    </>
  );
}

export default OMSHome;
